// extracted by mini-css-extract-plugin
export default {"couponCard":"_1AORUYQeDjtIjYjjsyPoRe","couponCard--exclusive":"TALo9Xl0DcZFFuIUR6hyY"};